// components/Industries.js
import React from 'react';
import './Industries.css';

const Industries = () => {
  const industries = [
    { icon: '🏢', name: 'Real Estate Brokers & Builders' },
    { icon: '📚', name: 'Coaching Institutes & Skill Academies' },
    { icon: '🏥', name: 'Healthcare Providers (Clinics, Dentists)' },
    { icon: '🛍️', name: 'Retail Business Owners' },
    { icon: '💼', name: 'Financial Consultants & Advisors' },
    { icon: '🏠', name: 'Home Services (Interior, Renovation)' }
  ];

  return (
    <section id="industries" className="industries-section fade-in-section">
      <div className="container">
        <h2 className="section-title">Who We Work With</h2>
        <p className="section-subtitle">
          Whether you're a solopreneur or a large business - if you want real, verified leads, LeadVala is your go-to partner.
        </p>
        
        <div className="industries-grid">
          {industries.map((industry, index) => (
            <div key={index} className="industry-item">
              <span className="industry-icon">{industry.icon}</span>
              <span className="industry-name">{industry.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;